import { Position } from 'reactflow';

import styles from './NodeTypes.module.scss';
import { HiddenHandle } from './common';
import { NodeProps } from '../types';
import edgeStyles from '@/react_app/components/ReactFlow/EdgeTypes/EdgeTypes.module.scss';
export default function LoopConnectorNode({ sourcePosition = Position.Top, targetPosition = Position.Bottom }: NodeProps) {
	return (
		<div className={styles.centerizeSmallNode}>
			<HiddenHandle type="source" position={sourcePosition} />
			<div className={edgeStyles.loopConnectorPath}>
				<div className={edgeStyles.loopConnectorPathTopHandleCover} />
				<div className={edgeStyles.loopConnectorPathBottomHandleCover} />
			</div>
			<HiddenHandle type="target" position={targetPosition} />
		</div>
	);
}
